var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('userMain',{attrs:{"userDetails":_vm.userDetails,"partnerpreference":_vm.partnerpreference,"partnerpreferenceList":_vm.partnerpreferenceList,"dropDownList":_vm.dropDownList},on:{"getUserProfile":_vm.userProfile,"getsoulprefernce":_vm.Getsoulpreference}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }